import { Button, CompactButton, Heading } from "@ogt/ui";

interface MeasureSidebarProps {
  open: boolean;
  onToggle: () => void;
  measuring: boolean;
  onToggleMeasuring: () => void;
  onClearMeasurement: () => void;
  measurePoints: google.maps.LatLngLiteral[];
  totalDistanceKm: number;
}

function MeasureSidebar({
  measuring,
  onToggleMeasuring,
  onClearMeasurement,
  measurePoints,
  totalDistanceKm,
}: MeasureSidebarProps) {
  return (
    <div className="p-4 pb-6 pt-0">
      <Heading>Rita och mäta på kartan</Heading>
      <p>Här kan du rita ut en sträcka och mäta hur långt det är.</p>
      <Heading as="h3">Ritverktyg</Heading>
      <CompactButton
        showIcon
        iconName="ruler"
        iconPosition="left"
        variant="outline"
        direction="vertical"
        activated={measuring}
        onClick={onToggleMeasuring}
      >
        {measuring ? "Mäter" : "Mäta"}
      </CompactButton>

      <div className="mt-6">
        <Heading as="h4">Avstånd</Heading>
        <div className="flex justify-between w-full items-center">
          <p className=" mb-0">
            Sträcka totalt:{" "}
            {measurePoints.length > 1 ? totalDistanceKm.toFixed(2) : "0.00"} km
          </p>
          {measurePoints.length > 1 && (
            <Button
              size="medium"
              variant="ghost"
              showIcon
              iconName="trash"
              onClick={onClearMeasurement}
            >
              Ta bort
            </Button>
          )}
        </div>
      </div>

      <hr />
      <Heading as="h3" className="mb-4">
        Så här mäter du avstånd på kartan
      </Heading>
      <ul className="list-disc pl-6 gap-2 flex flex-col">
        <li>Klicka på knappen “Mäta” för att börja rita.</li>
        <li>Klicka på kartan för att sätta ut starten på sträckan.</li>
        <li>Fortsätt klicka på kartan för att sätta ut sträckan.</li>
        <li>Under Avstånd ser du hur lång sträckan är.</li>
        <li>Du kan bara mäta avstånd på en sträcka i taget.</li>
        <li>Klicka på ”Ta bort” för att mäta en ny sträcka.</li>
      </ul>
    </div>
  );
}

export default MeasureSidebar;
